<template>
  <naj-modal
    ref="previousRepliesModal"
    :title="local.previousReplies.title"
    :close-button="true"
    :width="1600"
    show-footer-close-button
    @onClose="closeModal"
  >
    <previous-replies>
      <template v-slot:actions />
    </previous-replies>
    <template v-slot:actions>
      <router-link :to="`/lawsuit-requests/${requestObjectKey}/previous-replies/print?print=1${courtsQueryString}`">
        <naj-button
          v-if="requestObjectKey"
          outlined
        >
          {{ local.common.print }}
        </naj-button>
      </router-link>
    </template>
  </naj-modal>
</template>

<script>
import PreviousReplies from './previous-replies';
import { printPageByUrl } from '@/helpers/utils';
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('LawsuitModule');

export default {
  name: 'RequestRecordsModal',
  components: { PreviousReplies },
  props: ['modalVisibility', 'requestObjectKey', 'isCourtsRequestPreviousReplies'],
  computed: {
    courtsQueryString() {
      return this.isCourtsRequestPreviousReplies ? '&courts=1' : '';
    },
  },
  methods: {
    ...mapActions(['getCasePreviousReplies', 'resetCasePreviousReplies']),
    showModal () {
      this.$refs.previousRepliesModal.show();
    },
    closeModal () {
      this.$emit('onClose');
    },
    printTable () {
      printPageByUrl(`/lawsuit-requests/${this.requestObjectKey}/previous-replies/print?print=1`);
    },
  },
  watch: {
    modalVisibility (newValue) {
      if (newValue) {
        this.$refs.previousRepliesModal.show();
      }
    },
    requestObjectKey (value) {
      if (value) {
        this.getCasePreviousReplies({
          objectKey: value,
          isCourtsRequestPreviousReplies: this.isCourtsRequestPreviousReplies,
        });
      }else {
        this.resetCasePreviousReplies();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
